// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LrCh","placeholdersHeader":"styles_placeholdersHeader__1cLuI","editorStyle":"styles_editorStyle__3lTia","placeholdersBox":"styles_placeholdersBox__1okTw"};